import {
  REQUEST_CONST,
  RECEIVE_CONST,
  CONST_FAILED
} from '../actions/types';

function constantRequest(state = {}, action) {
  switch(action.type) {
    case RECEIVE_CONST:
      return Object.assign({}, state, {
        isFetching: false,
        constants: action.constants
      });
    case REQUEST_CONST:
      return Object.assign({}, state, {
        isFetching: true,
        constants: []
      });
    case CONST_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        constants: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default constantRequest;
